import React from 'react'
import { Label } from 'semantic-ui-react'

export const DateHeader = ({ startDate, counts, showMissingMatches, handleShowMissingMatches }) => {
  return <div className="match-date-header header-flex">
    <div>{startDate}</div>
    <div className='hi-right'>
      {counts.matchDay > 0 && <Label size='tiny' className={'rmd'} title='Match Day'>{counts.matchDay}</Label>}
      {counts.missing > 0 && <Label size='tiny' className={showMissingMatches ? 'miss-o' : 'miss'} title='Missing' onClick={() => { handleShowMissingMatches() }}>{counts.missing}</Label>}
      <Label size='tiny' color='black' title={'Total'}>{counts.total}</Label>
    </div>
  </div>
}
